import { cleanupExpiredSessions } from '@/lib/secure-storage';
import { logger } from '@/utils/logger';

/**
 * Session Cleanup Manager
 * Runs cleanup of expired sessions from secure storage
 */

let cleanupInterval: NodeJS.Timeout | null = null;

/**
 * Initializes automatic cleanup of expired sessions
 * Runs on app startup and periodically
 */
export const initializeSessionCleanup = async () => {
  try {
    // Run initial cleanup
    await cleanupExpiredSessions();
    logger.info('[Session Cleanup] Initial cleanup completed');

    // Schedule periodic cleanup (every 5 minutes)
    if (!cleanupInterval) {
      cleanupInterval = setInterval(async () => {
        try {
          await cleanupExpiredSessions();
          logger.info('[Session Cleanup] Periodic cleanup completed');
        } catch (error) {
          logger.error('[Session Cleanup] Periodic cleanup failed:', error);
        }
      }, 5 * 60 * 1000); // 5 minutes
    }
  } catch (error) {
    logger.error('[Session Cleanup] Initialization failed:', error);
  }
};

/**
 * Stops the automatic cleanup interval
 */
export const stopSessionCleanup = () => {
  if (cleanupInterval) {
    clearInterval(cleanupInterval);
    cleanupInterval = null;
    logger.info('[Session Cleanup] Stopped');
  }
};
